import Link, { LinkProps } from 'next/link';

type NextLinkProps = {
  children: JSX.Element;
  avoidNextLink?: boolean;
  href: string;
  prefetch?: boolean;
} & LinkProps;

const defaultProps = {
  prefetch: false,
  avoidNextLink: false,
};

const NextLink = (props: NextLinkProps): JSX.Element => {
  const { avoidNextLink, href, locale, prefetch, children } = props;

  if (avoidNextLink) {
    return children;
  }

  if (prefetch) {
    return (
      <Link href={href} locale={locale}>
        {children}
      </Link>
    );
  }

  return (
    <Link prefetch={prefetch} href={href} locale={locale}>
      {children}
    </Link>
  );
};

NextLink.defaultProps = defaultProps;

export type { NextLinkProps };
export default NextLink;
